import { useTranslation } from '@cobliteam/i18n';
import Popover, { PopoverContent, PopoverTrigger } from '@cobliteam/ui/components/Popover';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';

interface HelpPopoverProps {
  onOpen?: () => void;
}

export const HelpPopover = ({ onOpen }: HelpPopoverProps) => {
  const { t } = useTranslation('drivers');

  return (
    <Popover onOpenChange={(open) => open && onOpen?.()}>
      <PopoverTrigger aria-label={t('face_id.selector.help.open')}>
        <Icon name='circle-help' />
      </PopoverTrigger>
      <PopoverContent className='flex w-72 flex-col gap-2'>
        <Typography variant='text-md-semibold'>{t('face_id.selector.help.title')}</Typography>
        <Typography variant='text-md' color='secondary'>
          {t('face_id.selector.help.intro')}
        </Typography>
        <ul className='list-outside list-disc space-y-2 pl-5'>
          <Typography variant='text-md' asChild>
            <li>
              <strong>{t('face_id.selector.help.items.low_quality_title')}</strong> —{' '}
              <Typography variant='text-md' color='secondary' as='span'>
                {t('face_id.selector.help.items.low_quality_body')}
              </Typography>
            </li>
          </Typography>
          <Typography variant='text-md' asChild>
            <li>
              <strong>{t('face_id.selector.help.items.processing_title')}</strong> —{' '}
              <Typography variant='text-md' color='secondary' as='span'>
                {t('face_id.selector.help.items.processing_body')}
              </Typography>
            </li>
          </Typography>
          <Typography variant='text-md' asChild>
            <li>
              <strong>{t('face_id.selector.help.items.linked_title')}</strong> —{' '}
              <Typography variant='text-md' color='secondary' as='span'>
                {t('face_id.selector.help.items.linked_body')}
              </Typography>
            </li>
          </Typography>
        </ul>
      </PopoverContent>
    </Popover>
  );
};

export default HelpPopover;
